document.addEventListener("DOMContentLoaded", function () {
  const menuOpenBtn = document.querySelector(".menu_open");
  const mobileMenuWrap = document.querySelector(".mobile_menu_wrap");
  const menuOverlay = document.querySelector(".menu_overlay");
  const headerGroup = document.querySelector(".shopify-section-group-header-group");

  // Select the two SVGs
  const hambIcon = document.querySelector(".menu_open .icon_open"); 
  const closeIcon = document.querySelector(".menu_open .icon_close");

  // -------------------------
  // MENU TOGGLER
  // -------------------------
  menuOpenBtn?.addEventListener("click", () => {
    const isOpen = mobileMenuWrap.classList.toggle("menu_show");

    if (menuOverlay) {
      menuOverlay.style.display = isOpen ? "block" : "none";
    }

    // Apply overflow-hidden to html and body
    document.documentElement.classList.toggle("overflow-hidden", isOpen);
    document.body.classList.toggle("overflow-hidden", isOpen);

    // 🔥 ADD / REMOVE CLASS ON HEADER GROUP
    if (headerGroup) {
      headerGroup.classList.toggle("menu-open-header", isOpen);
    }

    // Show/hide SVGs
    if (hambIcon && closeIcon) {
      hambIcon.style.display = isOpen ? "none" : "inline-block";
      closeIcon.style.display = isOpen ? "inline-block" : "none";
    }
  });

  // -------------------------
  // CLOSE MENU
  // -------------------------
  document.querySelectorAll(".menu_close, .menu_overlay").forEach((el) =>
    el.addEventListener("click", closeAllMenus)
  );

  // -------------------------
  // SUBMENU GENERATION
  // -------------------------
  document.querySelectorAll(".mobile_menu_wrap ul li").forEach((li) => {
    if (li.querySelector("ul")) {
      li.classList.add("hassub");

      const subOpen = document.createElement("a");
      subOpen.href = "javascript:;";
      subOpen.className = "sub_menu_open";
      subOpen.innerHTML = `<i class="bi bi-plus"></i>`;
      li.appendChild(subOpen);
    }
  });

  document.querySelectorAll(".mobile_menu_wrap ul li ul").forEach((ul) => {
    const backLi = document.createElement("li");
    backLi.className = "back_to_mainmenu";
    backLi.innerHTML = `<a href="javascript:;"><i class="bi bi-chevron-left"></i> Back</a>`;
    ul.appendChild(backLi);
  });

  document.querySelectorAll(
    "li.hassub a[href='#'], li.hassub a[href='javascript:;'], li.hassub a[href='javascript:void(0);']"
  ).forEach((a) => a.classList.add("no_link"));

  // -------------------------
  // TAB SWITCHER
  // -------------------------
  const tabs = document.querySelectorAll(".mobile_menu_wrap .nav-tabs a");
  const tabContents = document.querySelectorAll(".menu_contents_wrap > div");

  function hideAllTabs() {
    tabContents.forEach((c) => (c.style.display = "none"));
    tabs.forEach((t) => t.classList.remove("active"));
  }

  hideAllTabs();
  const firstTabContent = document.querySelector("#shop_wrap");
  const firstTab = document.querySelector('.nav-tabs a[href="#shop_wrap"]');
  if (firstTabContent) firstTabContent.style.display = "block";
  if (firstTab) firstTab.classList.add("active");

  tabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      const href = tab.getAttribute("href");
      if (!href || href.startsWith("javascript:")) return;

      const content = document.querySelector(href);
      if (!content) return;

      hideAllTabs();
      content.style.display = "block";
      tab.classList.add("active");
    });
  });

  // -------------------------
  // CLICK HANDLERS
  // -------------------------
  mobileMenuWrap.addEventListener("click", function (e) {
    const target = e.target.closest("a.no_link");
    if (target) {
      e.preventDefault();
      const submenu = target.nextElementSibling;
      if (submenu && submenu.classList.contains("show_submenu")) {
        closeSubmenuAndChildren(submenu);
      } else if (submenu) {
        openSubmenu(submenu);
      }
    }
  });

  mobileMenuWrap.addEventListener("click", function (e) {
    if (e.target.closest(".back_to_mainmenu")) {
      const submenu = e.target.closest(".back_to_mainmenu").parentElement;
      closeSubmenuAndChildren(submenu);
    }
  });

  mobileMenuWrap.addEventListener("click", function (e) {
    const btn = e.target.closest(".sub_menu_open");
    if (btn) {
      e.preventDefault();
      const submenu = btn.previousElementSibling;
      if (submenu.classList.contains("show_submenu")) {
        closeSubmenuAndChildren(submenu);
      } else {
        openSubmenu(submenu);
      }
    }
  });

  // document.querySelectorAll(".mobile_menu_wrap ul li a").forEach((link) => {
  //   link.addEventListener("click", (e) => {
  //     const href = link.getAttribute("href");

  //     if (link.closest(".nav-tabs")) return;

  //     if (
  //       href === "#" ||
  //       href === "javascript:;" ||
  //       href === "javascript:void(0);" ||
  //       link.classList.contains("no_link") ||
  //       link.classList.contains("sub_menu_open")
  //     ) {
  //       return;
  //     }

  //     closeAllMenus();
  //   });
  // });

  // -------------------------
  // FUNCTIONS
  // -------------------------
  function closeAllMenus() {
    mobileMenuWrap?.classList.remove("menu_show");

    if (menuOverlay) menuOverlay.style.display = "none";

    document
      .querySelectorAll(".mobile_menu_wrap ul li ul")
      .forEach((ul) => ul.classList.remove("show_submenu"));

    document.documentElement.classList.remove("overflow-hidden");
    document.body.classList.remove("overflow-hidden");

    // 🔥 REMOVE CLASS FROM HEADER GROUP
    if (headerGroup) {
      headerGroup.classList.remove("menu-open-header");
    }

    if (hambIcon && closeIcon) {
      hambIcon.style.display = "inline-block";
      closeIcon.style.display = "none";
    }

    document
      .querySelectorAll(".sub_menu_open .bi")
      .forEach((i) => i.classList.replace("bi-dash", "bi-plus"));
  }

  function openSubmenu(submenu) {
    submenu.classList.add("show_submenu");
    submenu.parentElement
      .querySelector(".sub_menu_open .bi")
      ?.classList.replace("bi-plus", "bi-dash");
  }

  function closeSubmenuAndChildren(submenu) {
    submenu.classList.remove("show_submenu");

    submenu.querySelectorAll("ul.show_submenu").forEach((child) => {
      child.classList.remove("show_submenu");
    });

    submenu
      .querySelectorAll(".sub_menu_open .bi")
      .forEach((i) => i.classList.replace("bi-dash", "bi-plus"));

    submenu.parentElement
      .querySelector(".sub_menu_open .bi")
      ?.classList.replace("bi-dash", "bi-plus");
  }
});
